// extracted by mini-css-extract-plugin
var _1 = "ra-login";
var _2 = "ra-login-form";
var _3 = "ra-login-form-footer-center";
var _4 = "ra-login-form-footer";
var _5 = "ra-login-form-title";
export { _1 as "loginCls", _2 as "loginFormCls", _3 as "loginFormFooterCenterCls", _4 as "loginFormFooterCls", _5 as "loginFormTitleCls" }
